<template>
  <v-container grid-list-xl class="pa-5" v-if="presensi">
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-alert
            class="my-3 mb-5 body-2"
            v-if="currentJobs && is_premium"
            dense
            text
            :type="currentJobs.status == 2 ? 'info' : 'warning'"
          >
            <v-row class="my-0 py-0">
              <v-col cols="12" sm="12" md="9" lg="9">
                <div>
                  Proses Rekapitulasi Kehadiran tanggal
                  <strong>{{ currentJobs.tgl_awal | toD }} s/d {{ currentJobs.tgl_akhir | toD }}</strong>
                  oleh
                  <strong> {{ getDeepObj(currentJobs, 'user.nama') }} </strong>
                  pukul
                  <strong>{{ currentJobs.updated_at | toDT }}</strong
                  >&nbsp;
                  <span class="font-weight-bold">{{
                    currentJobs.status == 2 ? 'selesai.' : 'dalam proses perhitungan.'
                  }}</span>
                  <p class="mb-0 pb-0" v-if="currentJobs.status == 1">
                    Silakan cek kembali pada halaman ini secara berkala
                  </p>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3">
                <m-button
                  small
                  dark
                  depressed
                  color="info"
                  action="reloadJobs"
                  @reloadJobs="cekJobs"
                  icon="mdi-refresh"
                  text="Muat Ulang"
                ></m-button>
              </v-col>
            </v-row>
          </v-alert>
          <m-card>
            <m-card-list
              two-line
              title="Laporan Kehadiran Harian"
              :items="presensi"
              :headers="headers"
              :page="page"
              select
              filterStatusKehadiran
              refresh
              @refresh="load"
              filterUser
              filterWaktu
              filterGrup
              filterAktivasi
              :generateRekap="isCan('presensi.generate-verval')"
              @generate="toGenerate"
              @filter="filter"
              :idKey="'tgl_presensi'"
              footer
              @change:page="
              (pg) => {
                cp = pg
                load()
              }
            "
            >
              <template v-slot:action_tools>
                <v-menu v-if="isUnduhLaporan && isCan('presensi.download-kehadiran') && is_langganan_simpatika" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark depressed small class="py-4 mr-1" v-bind="attrs" v-on="on">
                      Unduh Laporan <v-icon right>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="onUnduhLaporan('pdf')">
                      <v-list-item-title>Format PDF</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="onUnduhLaporan('xls')">
                      <v-list-item-title>Format XLSX</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:items="{ item }" class="mt-5">
                <tr v-if="$vuetify.breakpoint.smAndUp">
                  <td class="text-left" width="20%">
                    <b>{{ getDeepObj(item, 'users.nama') }}</b><br/>
                    {{ getDeepObj(item, 'tgl_presensi') | toD }}<br/>
                    {{ getDeepObj(item, 'nama_jadwal') }}
                  </td>
                  <td class="text-left">
                    <span class="caption">Rencana:</span> {{ $setTimezone(item.jam_datang, 2) | formatTime }} <br/>
                    <span class="caption">Realisasi:</span> {{ $setTimezone(item.datang, 2) | formatTime }} <br/>
                    <span class="caption">Terlambat:</span> {{ item.terlambat > 0 ? `${item.terlambat} Menit` : '-' }}
                  </td>
                  <td class="text-left" width="30%">
                    <span class="caption"> Rencana Awal:</span> {{ $setTimezone(item.jam_istirahat_mulai, 2) | formatTime }}<br/>
                    <span class="caption">Realisasi Awal:</span> {{ $setTimezone(item.istirahat_mulai, 2) | formatTime }} <br/>
                    <span class="caption">Rencana Akhir:</span> {{ $setTimezone(item.jam_istirahat_selesai, 2) | formatTime }} <br/>
                    <span class="caption">Realisasi Akhir:</span> {{ $setTimezone(item.istirahat_selesai, 2) | formatTime }} <br/>
                  </td>
                  <td class="text-left">
                    <span class="caption">Rencana:</span> {{ $setTimezone(item.jam_pulang, 2) | formatTime }} <br/>
                    <span class="caption">Realisasi:</span> {{ $setTimezone(item.pulang, 2) | formatTime }} <br/>
                    <span class="caption">Pulang Cepat:</span> {{ item.pulang_cepat > 0 ? `${item.pulang_cepat} Menit` : '-' }}
                  </td>
                  <td class="text-left">
                    <span class="caption">Skor Datang:</span> {{ item.skor_datang }}<br/>
                    <span class="caption">Skor Pulang:</span> {{ item.skor_pulang }}
                  </td>
                  <td class="text-left">
                    <m-chip v-if="item.is_klaim" title="Klaim Presensi" color="warning" />
                    <m-chip v-else-if="item.is_libur" title="Hari Libur" color="info" />
                    <m-chip v-else-if="item.is_hadir" title="Hadir" color="success" />

                    <m-chip v-else-if="item.cuti_kategori_id" :title="getDeepObj(item, 'cuti_kategori.nama') || 'Ketidakhadiran'" color="warning" />
                    <m-chip v-else title="Alpa" color="error" />
                  </td>
                </tr>
                <tr v-else>
                  <td class="v-data-table__mobile-row">
                    <div class="v-data-table__mobile-row__header mr-2">
                      Tanggal
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      {{ getDeepObj(item, 'tgl_presensi') | toD }}
                    </div>
                  </td>
                  <td class="v-data-table__mobile-row">
                    <div class="v-data-table__mobile-row__header mr-2">
                      Pengguna
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      {{ getDeepObj(item, 'users.nama') }}
                    </div>
                  </td>
                  <td class="v-data-table__mobile-row">
                    <div class="v-data-table__mobile-row__header mr-2">
                      Status
                    </div>
                    <div class="v-data-table__mobile-row__cell">
                      <m-chip v-if="item.is_klaim" title="Klaim Presensi" color="warning" />
                      <m-chip v-else-if="item.is_libur" title="Hari Libur" color="info" />
                      <m-chip v-else-if="item.is_hadir" title="Hadir" color="success" />

                      <m-chip v-else-if="item.cuti_kategori_id" title="Ketidakhadiran" color="warning" />
                      <m-chip v-else title="Alpa" color="error" />
                    </div>
                  </td>
                </tr>
              </template>
            </m-card-list>
          </m-card>
        </v-col>
      </v-row>
    </v-form>
    <m-dialog ref="blocking" title="Peringatan" :fullscreen="false" :btnsave="false">
      <v-alert class="py-2" type="warning" text>
        Menu kalkulasi belum berjalan. Jika butuh kalkulasi, hubungi <a href="https://t.me/tanyajawabmasook001" target="_blank"> Admin masook </a><br/>
      </v-alert>
      <v-row>
        <v-col class="text-center" offset-md="3" cols="12" md="6">
          <v-img style="width: 500px" src="https://cdn.siap.id/s3/masook/asset%20img/SIM/img-default-block-fitur.jpg"></v-img>
        </v-col>
      </v-row>
    </m-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    kehadiran: {
      tanggalAwal: null,
      tanggalAkhir: null,
      is_hadir: 1,
      is_absen: 1,
      is_libur: 0,
      is_cuti: 1,
    },
    presensi: [],
    listJobs: [],
    listPeriode: [],
    users: [],
    currentJobs: null,
    page: null,
    cp: 1,
    isUnduhLaporan: false,
    autoload: null,
    headers: [
      { text: 'Nama', align: 'center', value: 'tanggal', sortable: false },
      { text: 'Jam Masuk', align: 'center', value: 'scan_masuk', sortable: false },
      { text: 'Jam Istirahat', align: 'center', value: 'jam_istirahat_mulai', sortable: false },
      { text: 'Jam Pulang', align: 'center', value: 'scan_keluar', sortable: false },
      { text: 'Skor', align: 'center', value: 'pulang', sortable: false },
      { text: 'Status', align: 'center', value: 'keterangan', sortable: false },
    ],
  }),
  activated() {
    this.loadPeriode()
    this.cekJobs()
  },
  mounted() {
    // this.load();
    this.getUser()
  },
  methods: {
    loadPeriode() {
      this.$store
        .dispatch("periode/getAll", {
          organisasi_id: this.organisasi_id,
          params: {}
        })
        .then(res => {
          this.listPeriode = res.data.data;
          this.listPeriode.push({
            periode_laporan_id: 0,
            nama: "Pilih Berdasarkan tanggal",
            value: "custom"
          });
        })
        .catch(e => e);
    },

    load() {
      this.$store
        .dispatch('laporan/kalkulasiHarian', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            order_by_nama: true,
            tgl_awal: this.kehadiran.tanggalAwal,
            tgl_akhir: this.kehadiran.tanggalAkhir,
            is_hadir: this.kehadiran.is_hadir,
            is_absen: this.kehadiran.is_absen,
            is_libur: this.kehadiran.is_libur,
            is_ijin: this.kehadiran.is_cuti,
            user_id: this.kehadiran.user_id || 0,
            group_id: this.kehadiran.group_id || 0,
            is_aktif: this.kehadiran.is_aktif,
          },
        })

        .then((res) => {
          this.page = res.data
          this.presensi = res.data.data
        })
        .catch((e) => e)
    },
    getUser() {
      this.$store.dispatch('user/getUserAktif', { organisasi_id: this.organisasi_id }).then((res) => {
        this.users = [...res.data]
        this.users.unshift({
          user_id: 0,
          nama: 'Semua Anggota',
        })
      })
    },
    cekJobs() {
      this.$store
        .dispatch('laporan/cekJobs', this.organisasi_id)
        .then((res) => {
          this.listJobs = res.data
          this.currentJobs = res.data[res.data.length - 1]
          return res
        })
        .then(() => {
          if (this.currentJobs && this.currentJobs.status === 1) {
            this.autoload = setInterval(() => {
              this.checkJobsPeriodik()
            }, 20000)
          }
        })
        .then(() => this.load())
        .catch((e) => e)
    },

    checkJobsPeriodik() {
      // clearTimeout(this.debounce)
      this.$store
        .dispatch('laporan/cekJobs', this.organisasi_id)
        .then((res) => {
          this.listJobs = res.data
          this.currentJobs = res.data[res.data.length - 1]
          return res
        })
        .then(() => {
          if (this.currentJobs && this.currentJobs.status === 2) {
            clearInterval(this.autoload)
          }
        })
    },

    toGenerate() {
      const date = new Date().getHours()
      // const openRestrict = []

      if (date < 8 && this.is_simpatika) {
        this.$infoDlg('Silakan melakukan proses kalkulasi setelah jam 08:00 WIB <br/><br/>Terima kasih<br/>', { okOnly: true })
        return
      }

      // const isBlocking = !openRestrict.includes(this.current_organisasi.kode_tenant)
      // if (isBlocking) {
      //   this.$refs.blocking.open()
      //   return
      // }

      this.$confirmDanger(
        `Pilih Anggota dan tanggal yang akan dikalkulasi?<br>`,

        {
          periode: this.listPeriode,
          users: this.users,
        },
        'Kalkulasi Kehadiran Harian'
      )
        .then((res) => {
          let from = ''
          let to = ''

          if (res && res.periode && res.periode.periode_laporan_id === 0){
            from = res.from
            to = res.to
          } else {
            from = res.periode && res.periode.tgl_mulai
            to = res.periode && res.periode.tgl_selesai
          }


          const diffDays = (date, otherDate) => Math.ceil(Math.abs(date - otherDate) / (1000 * 60 * 60 * 24))
          const countDate = diffDays(new Date(from), new Date(to))
          // maksimal range date 7 hari
          if (countDate <= 60) {
            this.$store
              .dispatch('laporan/kalkulasiKehadiran', {
                organisasi_id: this.organisasi_id,
                params: {
                  page: this.cp,
                  tgl_awal: from,
                  tgl_akhir: to,
                  user_id: res.user,
                },
              })
              .then(() => {
                this.$success('Aksi berhasil dijalankan')
                this.load()
                this.cekJobs()
              })
              .catch((e) => e)
          } else {
            this.$error('Maksimal jarak tanggal rekapitulasi kehadiran yang bisa diproses 7 hari')
          }
        })
        .catch((e) => e)
    },
    filter(data) {
      this.cp = 1
      this.kehadiran.tanggalAwal = data.from ? data.from : null
      this.kehadiran.tanggalAkhir = data.to ? data.to : null

      this.kehadiran.user_id = data && data.user
      this.kehadiran.group_id = data && data.grup
      this.kehadiran.is_hadir = data.is_hadir == true ? 1 : null
      this.kehadiran.is_absen = data.is_absen == true ? 1 : null
      this.kehadiran.is_libur = data.is_libur == true ? 1 : null
      this.kehadiran.is_cuti = data.is_cuti == true ? 1 : null
      this.kehadiran.is_aktif = ![undefined, null, ''].includes(data.statusAktivasi) ? data.statusAktivasi : ''

      this.isUnduhLaporan = !!Object.keys(data).length

      this.load()
    },
    changeDate() {
      if (this.kehadiran.tanggalAkhir < this.kehadiran.tanggalAwal)
        this.kehadiran.tanggalAkhir = this.kehadiran.tanggalAwal
    },
    onUnduhLaporan(format) {
      if (this.kehadiran.tanggalAwal || this.kehadiran.tanggalAkhir) {
        const diffDays = (date, otherDate) => Math.ceil(Math.abs(date - otherDate) / (1000 * 60 * 60 * 24))
        const countDate = diffDays(new Date(this.kehadiran.tanggalAwal), new Date(this.kehadiran.tanggalAkhir))

        if (countDate > 31) {
          this.$error('Batas tanggal tidak boleh lebih dari 30 hari')
          return
        }
      }

      this.$store
        .dispatch('laporan/unduhLaporanGrup', {
          organisasi_id: this.organisasi_id,
          params: {
            tgl_awal: this.kehadiran.tanggalAwal,
            tgl_akhir: this.kehadiran.tanggalAkhir,
            group_id: this.kehadiran.group_id || 0,
            user_id: this.kehadiran.user_id || null,
            format: format
          },
        })

        .then((url) => {
          if (url) window.open(url, '_blank')
        })
    },
  },
}
</script>
